import React, { useContext, useEffect, useState } from "react";
import { modalOpertaionFlag } from "../../../../../customer/Index";
import { Operation } from "../../../../../../../utils/Enum.types";
import {
  DEFAULT_TIME,
  EMPTY_STRING,
  ROWS_PER_PAGE,
  emptyMessage,
} from "../../../../../../../utils/constants";

import { AppContext } from "../../../../../../../context/context";
import useFormJson from "../../../../../../../json/useFormJson";
import useUrlParams from "../../../../../../../customHooks/useUrlParams";
import MessageModal from "../../../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../../../pages/LoadingModal";
import useLabels from "../../../../../../../customHooks/useLabels";
import useLoggedInUserDetails from "../../../../../../../customHooks/useLoggedInUserDetails";
import { Form, Formik, FormikProps } from "formik";
import { Title } from "../../../../../../../stories/Title/Title";
import Close from "../../../../../../../images/Close.svg";
import { LabelProps } from "../../../../../../../utils/types";
import { Button } from "../../../../../../../stories/Button/Button";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  OrderDirection,
  nodeVar,
} from "../../../../../../../utils/commonQueryTypes";
import { GetItemsDetailsById } from "./queries/queries";
import InputHoc from "../../../../../../common/Input/Index";
import {
  AtsStckItemDetails,
  ItemDetailsFormDataType,
  UpdateItemDetailsResult,
  UpdateItemDetailsVar,
} from "./queries/types";
import { itemDetaildsValidation } from "../../../../../../../utils/validationSchema";
import {
  removeMoreSpace,
  toInputStandardDate,
  toIsoDate,
  toStandardDate,
} from "../../../../../../../utils/UtilFunctions";
import { UpdateItemDetails } from "./queries/mutations";
import { payloadTypes } from "../../../../../../../context/reducer";
import {
  AtsStckItemDetailsOrderField,
  ItemDetailsQueryType,
} from "../../../items/queries/types";
import { GetItemsDetails } from "../../../items/queries/queries";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<modalOpertaionFlag>>;
  operation: Operation;
}

const AddItemDetails = ({ setModalFlag, operation }: Props) => {
  const [message, setMessage] = useState(emptyMessage);
  
  const { state, dispatch } = useContext(AppContext);
  const { ItemDetailsFormLabels } = useFormJson();
  const { itemLabel } = useLabels();
  const { customer_id, company_id, sub_id, siteID, junctionID } =
    useUrlParams();
  const emptyFormData: ItemDetailsFormDataType = {
    itemDesc: "",
    alias: "",
    poleNum: 0,
    prodSerialNo: "",
    prodBatchNo: "",
    prodBrand: "",
    prodModel: "",
    prodExpiryDate: "",
    prodWarrantyStartDate: "",
    prodWarrantyEndDate: "",
    prodInstallationEndDate: "",
    prodAmcStDate: "",
    prodAmcEndDate: "",
    prodInsuranceStDate: "",
    prodInsuranceEndDate: "",
    prodLatitude: "",
    prodLongitude: "",
    propertyData1: "",
    propertyData2: "",
    propertyData3: "",
    propertyData4: "",
    propertyData5: "",
    propertyData6: "",
    propertyData7: "",
    propertyData8: "",
    propertyData9: "",
    propertyData10: "",
    address: ""
  };

  const [formData, setFormData] =
    useState<ItemDetailsFormDataType>(emptyFormData);
  const { user_details } = useLoggedInUserDetails();

  const [getItemsDetailsById, { data, loading: getLoading }] = useLazyQuery<
    { node: AtsStckItemDetails },
    nodeVar
  >(GetItemsDetailsById);

  const [updateItemDetails, { loading: updateLoading }] = useMutation<
    UpdateItemDetailsResult,
    UpdateItemDetailsVar
  >(UpdateItemDetails, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<ItemDetailsFormDataType>
  ) => {
    const { name, value } = e.target as HTMLInputElement;
    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };
  const handleSubmit = async () => {
    try {
      
      if (operation === Operation.UPDATE) {
        if (customer_id ) {
          let input = {
            alias: formData.alias,
            poleNum: formData.poleNum,
            prodSerialNo: formData.prodSerialNo,
            prodBatchNo: formData.prodBatchNo,
            prodBrand: formData.prodBrand,
            prodModel: formData.prodModel,
            prodExpiryDate: toIsoDate(formData.prodExpiryDate),
            prodWarrantyStartDate: toIsoDate(formData.prodWarrantyStartDate),
            prodWarrantyEndDate: toIsoDate(formData.prodWarrantyEndDate),
            prodInstallationEndDate: toIsoDate(
              formData.prodInstallationEndDate
            ),
            prodAmcStDate: toIsoDate(formData.prodAmcStDate),
            prodAmcEndDate: toIsoDate(formData.prodAmcEndDate),
            prodInsuranceStDate: toIsoDate(formData.prodInsuranceStDate),
            prodInsuranceEndDate: toIsoDate(formData.prodInstallationEndDate),
            prodLatitude: formData.prodLatitude,
            prodLongitude: formData.prodLongitude,
            propertyData1: formData.propertyData1,
            propertyData2: formData.propertyData2,
            propertyData3: formData.propertyData3,
            propertyData4: formData.propertyData4,
            propertyData5: formData.propertyData5,
            propertyData6: formData.propertyData6,
            propertyData7: formData.propertyData7,
            propertyData8: formData.propertyData8,
            propertyData9: formData.propertyData9,
            propertyData10: formData.propertyData10,
            address: removeMoreSpace(formData.address),
          };

          updateItemDetails({
            variables: {
              
              user_details,
              customerID: customer_id,
              itemDetailsID: state.itemDetailsId,
              input: input,
            },
            refetchQueries: [
              {
                query: GetItemsDetails,
                variables: {
                  
                  customerID: customer_id ? customer_id : 0,
                  companyID: company_id ? company_id : 0,
                  subsidiaryID: sub_id ? sub_id : 0,
                  siteID: siteID ? siteID : 0,
                  junctionID: junctionID ? junctionID : 0,
                  input: {
                    query_type: ItemDetailsQueryType.ALL,
                    stckCategoryID: 0,
                    stckGroupID: 0,
                    stckManufacturerID: 0,
                    stckUomID: 0,
                    stckSubCategoryID: 0,
                    itemID: 0,
                    ldgrID: 0,
                  },
                  after: null,
                  first: ROWS_PER_PAGE,
                  name: EMPTY_STRING,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: AtsStckItemDetailsOrderField.CREATED_AT,
                  },
                },
              },
            ],
          }).then(({ data }) => {
            if (data && data.UpdateItemDetails) {
              setMessage({
                flag: true,
                message: `${itemLabel} Details Updated successfully`,
                operation: Operation.UPDATE,
              });
              dispatch({
                type: payloadTypes.SET_ITEM_DETAILS_ID,
                payload: {
                  itemDetailsId: 0,
                },
              });
            }
          });
        }
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };

  const hanldeClear = () => {
    const inputElement = document.getElementsByName(
      "name"
    )[0] as HTMLInputElement;
    if (inputElement) inputElement.focus();

    setFormData(emptyFormData);
  };

  const handleClose = () => {
    setMessage(emptyMessage);
    if (message.operation !== Operation.NONE) {
      hanldeClear();
      setModalFlag({
        flag: false,
        operation: Operation.CREATE,
      });
    }
  };

  useEffect(() => {
    if (operation === Operation.UPDATE) {
      getItemsDetailsById({
        variables: {
          id: state.itemDetailsId,
          
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setFormData({
            itemDesc:data.node.item.desc,
            alias: data.node.alias,
            poleNum: data.node.poleNum,
            prodSerialNo: data.node.prodSerialNo,
            prodBatchNo: data.node.prodBatchNo,
            prodBrand: data.node.prodBrand,
            prodModel: data.node.prodModel,
            prodExpiryDate: toInputStandardDate(data.node.prodExpiryDate),
            prodWarrantyStartDate: toInputStandardDate(
              data.node.prodWarrantyStartDate
            ),
            prodWarrantyEndDate: toInputStandardDate(
              data.node.prodWarrantyEndDate
            ),
            prodInstallationEndDate: toInputStandardDate(
              data.node.prodInstallationEndDate
            ),
            prodAmcStDate: toInputStandardDate(data.node.prodAmcStDate),
            prodAmcEndDate: toInputStandardDate(data.node.prodAmcEndDate),
            prodInsuranceStDate: toInputStandardDate(
              data.node.prodInsuranceStDate
            ),
            prodInsuranceEndDate: toInputStandardDate(
              data.node.prodInsuranceEndDate
            ),
            prodLatitude: data.node.prodLatitude,
            prodLongitude: data.node.prodLongitude,
            propertyData1: data.node.propertyData1,
            propertyData2: data.node.propertyData2,
            propertyData3: data.node.propertyData3,
            propertyData4: data.node.propertyData4,
            propertyData5: data.node.propertyData5,
            propertyData6: data.node.propertyData6,
            propertyData7: data.node.propertyData7,
            propertyData8: data.node.propertyData8,
            propertyData9: data.node.propertyData9,
            propertyData10: data.node.propertyData10,
            address: data.node.address
          });
        }
      });
    }
  }, [operation, state.empId, data]);

  const handleNumberChange = (name: string, value: string) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <>
      <div className="cust_users__add--title">
        <Title>
          {operation === Operation.CREATE ? "Add" : "Update"} {itemLabel}{" "}
          Details
        </Title>
        <img
          src={Close}
          alt=""
          onClick={() => {
            hanldeClear();
            setModalFlag({
              flag: false,
              operation: Operation.CREATE,
            });
          }}
        />
      </div>
      <Formik
        initialValues={formData}
        validationSchema={itemDetaildsValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <>
              <div className="customer__add">
                <Form className="customer__add--edit">
                  <div className="cust_users__add--form-head">
                    <h4>{itemLabel} Details</h4>
                  </div>
                  <div className="customer__add--form-details row g-0">
                    <div className="col h-100">
                      {ItemDetailsFormLabels.leftForm.map(
                        (field: LabelProps, key: React.Key) => {
                          if (field.dataType === "date") {
                            return (
                              <React.Fragment key={key}>
                                <InputHoc
                                  LabelName={field.labelName}
                                  values={
                                    formData[field.inputName] !== DEFAULT_TIME
                                      ? formData[field.inputName]
                                      : ""
                                  }
                                  name={field.inputName}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  required={field.required}
                                  autoFocus={field.autoFocus}
                                  type={field.dataType}
                                />
                                {meta.touched &&
                                meta.errors[field.inputName] ? (
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                ) : null}
                              </React.Fragment>
                            );
                          } else if (field.dataType === "number") {
                            return (
                              <React.Fragment key={key}>
                                <InputHoc
                                  LabelName={field.labelName}
                                  values={formData[field.inputName]}
                                  name={field.inputName}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  required={field.required}
                                  autoFocus={field.autoFocus}
                                  type={field.dataType}
                                />
                                {meta.touched &&
                                meta.errors[field.inputName] ? (
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                ) : null}
                              </React.Fragment>
                            );
                          } else {
                            return (
                              <React.Fragment key={key}>
                                <InputHoc
                                  LabelName={field.labelName}
                                  values={formData[field.inputName]}
                                  name={field.inputName}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  required={field.required}
                                  autoFocus={field.autoFocus}
                                  type={field.dataType}
                                  disabled={field.disabled}
                                />
                                {meta.touched &&
                                meta.errors[field.inputName] ? (
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                ) : null}
                              </React.Fragment>
                            );
                          }
                        }
                      )}
                    </div>
                    <div className="col h-100">
                      {ItemDetailsFormLabels.rightForm.map(
                        (field: LabelProps, key: React.Key) => {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                autoFocus={field.autoFocus}
                              />
                              {meta.touched && meta.errors[field.inputName] ? (
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      )}
                    </div>
                  </div>
                  <Button mode="save" type="submit" />
                  <Button mode="clear" type="reset" onClick={hanldeClear} />
                  <Button
                    mode="cancel"
                    onClick={() =>
                      setModalFlag({
                        flag: false,
                        operation: Operation.NONE,
                      })
                    }
                  />
                </Form>
              </div>
            </>
          );
        }}
      </Formik>
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal flag={false} />
    </>
  );
};

export default AddItemDetails;
